import React, { FC } from 'react';
import { ServiceCard, ServiceCardButton, ServiceCardContent } from '../service-card';
import { cx } from 'linaria';
import { icon, markerStyles, verticalIcon, singleCompensatedService, singleServiceStyles } from './styles';
import { RelatedServiceProps } from '../types';
import { Marker } from 'fronton-react';

export const DATA_QA_RELATED_SERVICE_ICON = 'related-services-icon_mf-pdp';

export const RelatedService: FC<RelatedServiceProps> = ({
  service: { iconLeftSrc, title, price, isCompensationEnabled, serviceKey, serviceId },
  href,
  onClick,
  vertical,
  className,
  singleService,
}) => {
  const isCompensatedService = isCompensationEnabled && serviceKey === 'measurement';
  const isSingleVsCompensation = singleService && isCompensatedService;
  return (
    <ServiceCard
      onClick={onClick}
      href={href}
      vertical={vertical}
      className={className}
      serviceId={serviceId}
      containerClassName={cx(isSingleVsCompensation ? singleCompensatedService : undefined)}
    >
      <ServiceCardContent
        title={title}
        className={cx(isSingleVsCompensation ? singleServiceStyles : undefined)}
      >
        {isCompensatedService && (
          <Marker
            background="brand-primary"
            color="text-primary"
            variant="angular"
            charsLimit={30}
            size="s"
            text="Компенсируем при заказе услуги"
            className={markerStyles}
          />
        )}
        {!isCompensatedService && iconLeftSrc ? (
          <img
            className={cx(icon, vertical ? verticalIcon : null)}
            src={iconLeftSrc}
            alt={title}
            data-qa={DATA_QA_RELATED_SERVICE_ICON}
          />
        ) : null}
      </ServiceCardContent>
      <ServiceCardButton price={price?.value} />
    </ServiceCard>
  );
};
